import React from "react";
import { Row, Col, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { Card, CardBody, CardTitle } from "reactstrap";
import DatePicker from "react-datepicker";
import { IoCashOutline, IoCash } from "react-icons/io5";
import { GetLanguageString } from "../../../helper/Components";
import { useTranslation } from "react-i18next";
const CashToAmanatForm = ({
  values,
  errors,
  fundAccountBalances,
  handleInputChange,
  handleDateChange,
  handleFileChange,
  isEdit = false,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* BALANCE CARDS */}
      <Row>
        {/* Cash Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <Card
            className="border-0 shadow-lg"
            style={{ backgroundColor: "#E6FAF4", borderRadius: "20px" }}
          >
            <CardBody style={{ padding: "0.5rem" }}>
              <CardTitle tag="h5">
                <h4>
                  <GetLanguageString props="cash_account_balance" />
                </h4>
              </CardTitle>

              <div className="d-flex align-items-center gap-2 my-3">
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    backgroundColor: "#20D4A0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <IoCashOutline size={24} color="white" />
                </div>

                <h3 className="mb-0">
                  Rs{" "}
                  {new Intl.NumberFormat().format(
                    fundAccountBalances.cashAccountBalance
                  )}
                </h3>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Amanat Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <Card
            className="border-0 shadow-lg"
            style={{ backgroundColor: "#fef7ee", borderRadius: "20px" }}
          >
            <CardBody style={{ padding: "0.5rem" }}>
              <CardTitle tag="h5">
                <h4>
                  <GetLanguageString props="transactions_amanat_account_balance" />
                </h4>
              </CardTitle>

              <div className="d-flex align-items-center gap-2 my-3">
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    backgroundColor: "#f9b468",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <IoCash size={24} color="white" />
                </div>

                <h3 className="mb-0">
                  Rs{" "}
                  {new Intl.NumberFormat().format(
                    fundAccountBalances.amanatAccountBalance
                  )}
                </h3>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* FORM FIELDS */}

        {/* Transfer Amount */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="funds_add_fund_amount" />
            </Label>
            <Input
              type="text"
              name="transferAmount"
              placeholder={t("funds_add_fund_amount")}
              value={values.transferAmount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  handleInputChange({
                    target: { name: "transferAmount", value: val },
                  });
                }
              }}
              invalid={!!errors.transferAmount}
            />
            {errors.transferAmount && (
              <FormFeedback>
                <h4>{errors.transferAmount}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Bank Charges */}
        {!isEdit && (
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">
                <GetLanguageString props="transactions_bank_charges" />
              </Label>
              <Input
                type="text"
                name="bankCharge"
                placeholder="Bank Charges"
                value={values.bankCharge}
                onChange={handleInputChange}
                invalid={!!errors.bankCharge}
              />
            </FormGroup>
          </Col>
        )}
        {/* Deposit Date */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="dashboard_event_page_date" />
            </Label>
            <DatePicker
              selected={values.depositDate}
              onChange={handleDateChange}
              className={`form-control ${
                errors.depositDate ? "is-invalid" : ""
              }`}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
            />
            {errors.depositDate && (
              <div className="invalid-feedback d-block">
                <h4>{errors.depositDate}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        {/* Reference No */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_bank_deposit_slip_number" />
            </Label>
            <Input
              type="text"
              name="referenceNo"
              placeholder="Bank Deposit Slip Number"
              value={values.referenceNo || ""}
              onChange={(e) =>
                handleInputChange({
                  target: { name: "referenceNo", value: e.target.value },
                })
              }
              invalid={!!errors.referenceNo}
            />
            {errors.referenceNo && (
              <div className="invalid-feedback d-block">
                <h4>{errors.referenceNo}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        {/* File Upload */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="deposit_slip" />
            </Label>
            <Input
              type="file"
              accept="image/*,application/pdf"
              name="file"
              onChange={handleFileChange}
              invalid={!!errors.file}
            />
            {errors.file && (
              <FormFeedback>
                <h4>{errors.file}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Memo */}
        <Col md={isEdit ? "12" : "6"}>
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_memo" />
            </Label>
            <Input
              type="textarea"
              name="memo"
              placeholder="Memo"
              value={values.memo}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
export default CashToAmanatForm;
